import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "category",
  "use": "category-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"category\"><path d=\"M171.37 110.22H111a23.09 23.09 0 0 0-23.09 23.09v133.38A23.09 23.09 0 0 0 111 289.78h178a23.09 23.09 0 0 0 23.09-23.09V165.22A23.09 23.09 0 0 0 289 142.13h-85.72a31.91 31.91 0 0 1-31.91-31.91z\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol